module.exports = __webpack_public_path__ + "static/media/MATH 124.289d7f7f.jpg";